import React, { memo } from "react"
import Layout from "@layouts/Layout"
import { HomePage as Home } from "@screens/HomeV2"

const title = "Time Tracking Software with Team & Project Visibility | Traqq"
const description =
  "Time tracking software for teams of any size. Track employee work time, projects, and tasks, and understand team workload without surveillance. 14-day free trial."

const HomePage = () => (
  <Layout
    title={title}
    description={description}
    useTitleTemplate=""
    additionalMetaTags={[
      {
        itemProp: "name",
        content: "Employee Time Tracking Software - Traqq",
        keyOverride: "prop-name",
      },
      // TODO: probably need to change two additional meta tags below
      {
        itemProp: "description",
        content: "AI-powered time tracker and smart time tracking software that works as hard as you do. Lightweight, free and packed with productivity-boosting insights.",
        keyOverride: "prop-description",
      },
      {
        itemProp: "image",
        content: `${process.env.NEXT_PUBLIC_APP_URL}/traqq-time-tracker-features.png`,
        keyOverride: "prop-image",
      },
    ]}
  >
    <Home />
  </Layout>
)

export default memo(HomePage)
